import React from 'react';
import MainScreen from './screens/MainScreen';
import UIStore from './store/store';
import API from './helpers/api';

class App extends React.Component {
  componentDidMount() {
    const likedPoints = localStorage.getItem('likedPoints');
    if (likedPoints) {
      UIStore.likedPoints = JSON.parse(likedPoints);
    }

    API.getStreetViewData();
  }

  render() {
    return (
      <MainScreen />
    );
  }
}

export default App;
